var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "houseRent-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-23.958 -1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "houseRent",
    transform: "translate(23.958 1)",
    clipPath: "url(#houseRent-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.075,43.857,20.9,45.685A3.438,3.438,0,0,0,18,44.028l-3.853-.1A4.325,4.325,0,0,1,12.4,43.51l-.392-.188a7.4,7.4,0,0,0-6.4.006l.024-.823A.512.512,0,0,0,5.109,42L.885,41.89a.517.517,0,0,0-.547.48L.082,50.963a.512.512,0,0,0,.518.507l4.225.108h.015a.516.516,0,0,0,.533-.48l.012-.411,1.1-.545A2.016,2.016,0,0,1,7.887,50l6.554,1.7.035.008a7.629,7.629,0,0,0,4.41-.463.5.5,0,0,0,.066-.034l9.5-5.7a.473.473,0,0,0,.175-.658A2.8,2.8,0,0,0,25.075,43.857ZM1.162,50.5l.226-7.606,3.159.081-.226,7.606Zm17.244-.129a6.478,6.478,0,0,1-3.694.382l-6.536-1.7a3.155,3.155,0,0,0-2.2.223l-.561.279.15-5.057a6.253,6.253,0,0,1,5.949-.294l.392.188a5.47,5.47,0,0,0,2.212.529l3.853.1A2.3,2.3,0,0,1,20.2,46.741l-5.739-.147a.517.517,0,0,0-.547.48.512.512,0,0,0,.518.507l6.333.162h.015a.516.516,0,0,0,.532-.48,2.91,2.91,0,0,0-.052-.641l4.281-1.875.012-.005a1.728,1.728,0,0,1,1.841.239Z",
    transform: "translate(-0.037 -18.85)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.715,7.993l4.173-1.828a3.439,3.439,0,0,0,2.9,1.657l3.853.1a4.325,4.325,0,0,1,1.751.419l.392.188a7.4,7.4,0,0,0,6.4-.006l-.024.823a.512.512,0,0,0,.518.507l4.225.108a.517.517,0,0,0,.547-.48L64.708.887A.512.512,0,0,0,64.19.38L59.965.272h-.015a.516.516,0,0,0-.533.48l-.012.411-1.1.545a2.016,2.016,0,0,1-1.405.143L50.349.146,50.314.138A7.629,7.629,0,0,0,45.9.6a.508.508,0,0,0-.066.034l-9.5,5.7a.473.473,0,0,0-.175.658A2.8,2.8,0,0,0,39.715,7.993Zm23.913-6.64L63.4,8.96l-3.159-.081.226-7.606Zm-17.244.129A6.478,6.478,0,0,1,50.079,1.1l6.536,1.7a3.154,3.154,0,0,0,2.2-.223l.561-.279-.15,5.057a6.253,6.253,0,0,1-5.949.294l-.392-.188a5.471,5.471,0,0,0-2.212-.53l-3.853-.1A2.3,2.3,0,0,1,44.595,5.11l5.739.147a.517.517,0,0,0,.547-.48.512.512,0,0,0-.518-.507L44.03,4.108h-.015a.516.516,0,0,0-.532.48,2.91,2.91,0,0,0,.052.641L39.253,7.1l-.012.006A1.728,1.728,0,0,1,37.4,6.87Z",
    transform: "translate(-16.241)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.491,28.487a3.532,3.532,0,0,1-.745-.071l-.55.621a.577.577,0,0,1-.408.177h-.851v.9a.552.552,0,0,1-.55.55h-.9v.9a.552.552,0,0,1-.55.55h-2.5a.552.552,0,0,1-.55-.55V29.8a.55.55,0,0,1,.16-.39l3.67-3.67a4.13,4.13,0,0,1-.2-1.241,3.981,3.981,0,1,1,3.972,3.989ZM38.573,24.5a1.082,1.082,0,1,0-1.082-1.082A1.1,1.1,0,0,0,38.573,24.5Z",
    transform: "translate(-13.448 -9.229)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseRent);
export default __webpack_public_path__ + "static/media/houseRent.eb11b713b98f64e68a66530f45a7fce6.svg";
export { ForwardRef as ReactComponent };